<template>
  <div v-if="$route.path !== '/'" class="breadcrumb-container">
  <nav aria-label="breadcrumb" class="breadcrumb-container">
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <router-link to="/">Home</router-link>
      </li>
      <li
        v-for="(crumb, index) in breadcrumbs"
        :key="index"
        :class="['breadcrumb-item', { active: index === breadcrumbs.length - 1 }]"
        aria-current="page"
      >
        <span v-if="index === breadcrumbs.length - 1">{{ crumb.name }}</span>
        <router-link v-else :to="crumb.path">{{ crumb.name }}</router-link>
      </li>
    </ol>
  </nav>
</div>
</template>

<script>

import { useRoute } from 'vue-router';
import { ref, onMounted, watch } from 'vue';


export default {
  name: 'AppBreadcrumb',
  setup() {
    const route = useRoute();
    const breadcrumbs = ref([]);

    const routeToBreadcrumb = {
       '/about-us': [{ name: 'About Us', path: '/about-us' }],
      '/computer-science': [
        { name: 'Secondary', path: '#' },
        { name: 'Computer Science', path: '/computer-science' }
      ],
        '/computational-thinking': [
        { name: 'Secondary', path: '#' },
        { name: 'Computational Thinking', path: '/computational-thinking' }
      ],
      '/artificial-intelligence': [
        { name: 'Secondary', path: '#' },
        { name: 'Artificial Intelligence', path: '/artificial-intelligence' }
      ],
      '/exam-boards': [
        { name: 'Secondary', path: '#' },
        { name: 'Exam Baords', path: '/exam-boards' }
      ],
      '/courses': [{ name: 'Courses', path: '/courses' }],
      '/teaching': [{ name: 'Teaching Approach', path: '/teaching' }],
      '/contact': [{ name: 'Contact Us', path: '/contact' }],
      //'/blog': [{ name: 'Blog', path: '/blog' }],
       '/testimonials' : [{ name: 'Testimonials', path: '/testimonials'  }],
       '/school-partnerships' : [{ name: 'School Partnerships', path: '/school-partnerships'  }],
       '/learn-linux' : [{ name: 'Learn Linux', path: '/learn-linux'  }],
      // Add more as needed
    };

    const updateBreadcrumbs = () => {
      const matched = routeToBreadcrumb[route.path];
      breadcrumbs.value = matched || [];
    };

    onMounted(updateBreadcrumbs);
    watch(() => route.path, updateBreadcrumbs); // reacts to path changes

    return { breadcrumbs };
  }
};
</script>

<style scoped>
.breadcrumb-container {
  padding: 0.5rem 1rem;
  background-color: #f8f9fa;
  font-size: 0.9rem;
  color: #6c757d;
}

.breadcrumb a {
  color: #155724; /* dark green links */
  text-decoration: none;
}

.breadcrumb-item.active {
  color: #6c757d; /* muted text for current location */
}
</style>

